import type { AxiosInstance } from "axios";
import type { IFactoryFunctionRequest } from "@bc-library/interface";
import { EMethod } from "@bc-library/interface";
import { API_MAIN_VERSION, BASE_URL } from "@/config/constantes";
import useAxios from "@/services/api/useAxios";

const resource = "proposals";

export type ProposalStatus = "draft" | "sent" | "accepted" | "rejected" | "archived";

const showProject = (axios: IFactoryFunctionRequest<any, any>) => (projectId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/project/${projectId}`,
  });
};

const create =
  (axios: IFactoryFunctionRequest<any, any>) =>
  (data: {
    projectId: string;
    title?: string;
    status?: ProposalStatus;
    htmlBody?: string;
    documents?: unknown[];
    resources?: unknown[];
  }) => {
    return axios({
      method: EMethod.post,
      url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
      data,
    });
  };

const update =
  (axios: IFactoryFunctionRequest<any, any>) => (id: string, data: Record<string, unknown>) => {
    return axios({
      method: EMethod.put,
      url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${id}`,
      data,
    });
  };

const softDelete = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${id}`,
  });
};

const getOne = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${id}`,
  });
};

const toPowerpoint =
  (axios: IFactoryFunctionRequest<any, any>) => (data: Record<string, unknown>) => {
    return axios({
      method: EMethod.post,
      url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/topowerpoint`,
      data,
    });
  };

export default (axios: AxiosInstance) => ({
  showProject: showProject(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  softDelete: softDelete(useAxios(axios)),
  getOne: getOne(useAxios(axios)),
  toPowerpoint: toPowerpoint(useAxios(axios)),
});
